const STORAGE_PREFIX = 'chse_lesson_resume_';

export function getStoredLessonResumeSeconds(lessonId) {
  if (!lessonId) return 0;

  try {
    const value = window.localStorage.getItem(`${STORAGE_PREFIX}${lessonId}`);
    const seconds = Number(value);
    return Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
  } catch {
    return 0;
  }
}

export function setStoredLessonResumeSeconds(lessonId, seconds) {
  if (!lessonId) return;

  try {
    const safeSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
    if (safeSeconds > 0) {
      window.localStorage.setItem(`${STORAGE_PREFIX}${lessonId}`, String(safeSeconds));
    } else {
      window.localStorage.removeItem(`${STORAGE_PREFIX}${lessonId}`);
    }
  } catch {
    // Ignore storage failures.
  }
}

export function clearStoredLessonResumeSeconds(lessonId) {
  if (!lessonId) return;

  try {
    window.localStorage.removeItem(`${STORAGE_PREFIX}${lessonId}`);
  } catch {
    // Ignore storage failures.
  }
}

export function getLessonResumeSeconds(lessonId, apiWatchedSeconds = 0) {
  const apiSeconds = Math.max(0, Number(apiWatchedSeconds) || 0);
  const localSeconds = getStoredLessonResumeSeconds(lessonId);
  return Math.max(apiSeconds, localSeconds);
}
